export default __webpack_public_path__ + "static/after-66db8a3199c336e2c09d289462cb5cbd.jpg";